import playerResourceQuantityStore from "../store/playerResourceQuantity";


// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerResourceQuantity = (playerId) => {
    const playerResourceQuantitys = playerResourceQuantityStore((state) => state.playerResourceQuantitys);
    const updateSingleResourceQuantity = playerResourceQuantityStore((state) => state.updateSingleResourceQuantity);
    const updatePlayerResourceQuantity = playerResourceQuantityStore((state) => state.updatePlayerResourceQuantity);
    const updateMultiplePlayersQuantity = playerResourceQuantityStore((state) => state.updateMultiplePlayersQuantity);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        resourceQuantity: playerId == null ? {} : playerResourceQuantitys[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerResourceQuantitys,
        updateSingleResourceQuantity,
        updatePlayerResourceQuantity,
        updateMultiplePlayersQuantity,
    };
};

export default usePlayerResourceQuantity;
